// extracted by mini-css-extract-plugin
export default {"video":"Home_video__rlnRt"};